export const ROUTES = {
  "/": "home",
  "/research": "research",
  "/stories": "stories",
  "/findings": "findings",
  "/implications": "implications",
  "/building": "building",
};

export const TAB_ORDER = ["home", "research", "findings", "stories", "implications", "building"];

export const TAB_TO_PATH = Object.freeze(
  Object.fromEntries(Object.entries(ROUTES).map(([path, tab]) => [tab, path]))
);

export const STORY_IDS = ["maryam", "farhad", "borhan", "olaa", "sarah", "adnan", "nada-farooq"];

/** Direction for keyboard navigation. */
export const NAV_DIR = { NEXT: 1, PREV: -1, HOME: "home", END: "end" };

/**
 * Returns the next tab ID for keyboard navigation.
 * @param {string} currentTabId - The current tab ID
 * @param {number|string} direction - NAV_DIR.NEXT, NAV_DIR.PREV, NAV_DIR.HOME, or NAV_DIR.END
 * @returns {string} The target tab ID
 */
export function getNextTabId(currentTabId, direction) {
  const idx = TAB_ORDER.indexOf(currentTabId);
  if (idx === -1) return TAB_ORDER[0];
  if (direction === NAV_DIR.HOME) return TAB_ORDER[0];
  if (direction === NAV_DIR.END) return TAB_ORDER[TAB_ORDER.length - 1];
  if (direction === NAV_DIR.NEXT) return TAB_ORDER[(idx + 1) % TAB_ORDER.length];
  if (direction === NAV_DIR.PREV) return TAB_ORDER[(idx - 1 + TAB_ORDER.length) % TAB_ORDER.length];
  return TAB_ORDER[idx];
}

export function getTabFromPath(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  if (clean === "/" || ROUTES[clean]) {
    return ROUTES[clean] || "home";
  }
  if (/^\/stories(?:\/[a-z0-9-]+)?$/.test(clean)) return "stories";
  return "home";
}

export function getStoryFromPath(pathname) {
  const match = (pathname || "").match(/^\/stories\/([a-z0-9-]+)/);
  const id = match ? match[1] : null;
  return id && STORY_IDS.includes(id) ? id : null;
}

export function easeOutQuart(t) {
  return 1 - Math.pow(1 - t, 4);
}
